import React, { useState } from "react";

import NonEarningPartnersList from "./NonEarningPartnersList";

const RefernEarnNonEarningPartners = () => {
  const [currentScreen, setCurrentScreen] = useState({
    name: "list",
    data: null,
  });

  return (
    <div>
      <NonEarningPartnersList
        setCurrentScreen={setCurrentScreen}
        screenData={currentScreen.data}
      />
    </div>
  );
};

export default RefernEarnNonEarningPartners;
